import { IVAT } from "../../../../interfaces/IVat";
import ICategory from "../../categories/ICategory";
import ISubCategory from "../../categories/ISubCategory";
import IMenuItemBody from "../../../../interfaces/IMenuItemBody";
import { IExtraGroup } from "../../../../interfaces/IExtraGroup";
import { IPreference } from "../../preferences/PreferenceForm";
import { ITaxes } from "../../../../interfaces/ITaxes";

export const SET_CATEGORIES = "SET_CATEGORIES";

export function setCategories(category: ICategory[]) {
    console.log("SETTING CATES", category);
    return {
        type: SET_CATEGORIES,
        payload: category
    };
}

export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES";

export function setSubCategories(category: ISubCategory[]) {
    return {
        type: SET_SUB_CATEGORIES,
        payload: category
    };
}

export const SET_VAT = "SET_VAT";

export function setVAT(vat: IVAT[]) {
    return {
        type: SET_VAT,
        payload: vat
    };
}
export const SET_TAXES = "SET_TAXES";

export function setTaxes(taxes: ITaxes[]) {
    return {
        type: SET_TAXES,
        payload: taxes
    };
}

export const SET_MENU_ITEMS = "SET_MENU_ITEMS";

export function setMenuItems(menuItems: IMenuItemBody[]) {
    return {
        type: SET_MENU_ITEMS,
        payload: menuItems
    };
}

export const SET_IS_LOADING = "SET_IS_LOADING";

export function setIsLoading(isLoading: boolean) {
    return {
        type: SET_IS_LOADING,
        payload: isLoading
    };
}

export const SET_EXTRA_GROUPS = "SET_EXTRA_GROUPS";

export function setExtraGroups(extraGroups: IExtraGroup[]) {
    return {
        type: SET_EXTRA_GROUPS,
        payload: extraGroups
    };
}

export const SET_PREFERENCE_GROUPS = "SET_PREFERENCE_GROUPS";

export function setPreferenceGroups(preferences: IPreference[]) {
    return {
        type: SET_PREFERENCE_GROUPS,
        payload: preferences
    };
}

export const UPDATE_MENU_ITEM_POSITION = "UPDATE_MENU_ITEM_POSITION";

export function updateMenuItemPositions(menuItem: string[]) {
    return {
        type: UPDATE_MENU_ITEM_POSITION,
        payload: menuItem
    }
}

export const UPDATE_SUBCATEGORY_POSITION = "UPDATE_SUBCATEGORY_POSITION";

export function updateSubcategoryPositions(subcategories: string[]) {
    return {
        type: UPDATE_SUBCATEGORY_POSITION,
        payload: subcategories
    }
}

export const SET_TAGS = "SET_TAGS";


export function setDietaryTags(tags: any[]) {
    return {
        type: SET_TAGS,
        payload: tags
    }
}